import React from 'react';
import Wallets from './Wallets';

const WithdrawFiat = () => {
  return <Wallets />;
};

export default WithdrawFiat;